import { useTranslation } from 'react-i18next';

import { Icon } from '~/components/Icon';
import { Tooltip } from '~/components/Tooltip';

import type { Role } from '../api/lib/schemas';
import { UserRoleMap } from '../constants/UserRoleMap';

export function UserRole({ roles = [] }: { roles: Role[] }) {
  const { t } = useTranslation('settings', { keyPrefix: 'roles' });

  const availableRoles = roles.filter((role) =>
    Object.keys(UserRoleMap).includes(role),
  );

  if (!availableRoles.length) {
    return null;
  }

  const [shownRole, ...additionalRoles] = availableRoles;

  const multiRoleTooltip = (
    <ul className="m-0 max-h-[13rem] list-none space-y-md overflow-auto">
      {additionalRoles.map((role: Role) => (
        <li key={role}>
          <h3 className="font-bold">{t(`${UserRoleMap[role]}.name`)}</h3>
          <p>{t(`${UserRoleMap[role]}.description`)}</p>
        </li>
      ))}
    </ul>
  );

  return (
    <span>
      {t(`${UserRoleMap[shownRole]}.name`)}
      <Tooltip
        content={t(`${UserRoleMap[shownRole]}.description`)}
        side="top"
        delayDuration={0}
      >
        <Icon
          type="circle-info"
          variant="light"
          className="ml-sm text-subtlest"
          size="sm"
        />
      </Tooltip>
      {additionalRoles.length ? (
        <Tooltip content={multiRoleTooltip} side="top" delayDuration={0}>
          <span className="ml-md basis-md rounded-xs border px-sm py-xs text-center text-body-xs leading-5 bg-level-05 border-emphasis-subtle">
            +{additionalRoles.length}
          </span>
        </Tooltip>
      ) : null}
    </span>
  );
}

UserRole.displayName = 'UserRole';
